import { Table } from "react-bootstrap";
import styled, { StyledFunction } from "styled-components"

export const TableHeaderWrapper = styled.table`
    & > thead > tr > th {
        color: black;
        overflow: hidden;
        padding: 5px 0px 5px 3px !important;
    }
`;

export const TableRowWrapper = styled.tr`
    & > td {
        padding: 3px 0px 3px 3px !important;
        vertical-align: middle !important;
    }
`;

export const SummaryTitles = styled.tr`
    & > td {
        background-color: #00004c;
        color: white;
        font-size: 9px;
    }
`;

export const SummaryValues = styled.tr`
    & > td {
        font-size: 12px;
    }
`;

interface IGridWrapperProps {
    height?: string
    width?: string
}

export const GridWrapper = styled.div<IGridWrapperProps>`
    height: ${p => p.height ? p.height : '90vh'};
    width: ${p => p.width ? p.width : '100vh'};
    
    font-family: Roboto;

    .ag-header {
        background-color: #b0e0e6;
        color: black;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: .5px solid #ccc;
        border-bottom: .5px solid #ccc;
        border-right: .5px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }


.ag-theme-balham .ag-row.alternate-stripe {
    background-color: #f4f4f4; /* Odd row color */
}

.ag-theme-balham .ag-row.even-stripe {
    background-color: #e0e0e0; /* Even row color */
}



    .center-list-header {
        background-color: #b0e0e6;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: black;
        font-weight: bold;
    }

    .center-list-cell {
        height: 30px;
        border-width: .5px;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
        border-top: .5px solid #ddd;
        border-left: .5px solid #ddd;
        border-right: .5px solid #ddd;
    }

    .center-list-group-header {
        background-color: #b0e0e6;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-top: 10px;
        padding-bottom: 4px;
        color: black;
        font-weight: bold;
        font-size: 19px;
        border-bottom: 1px solid #ddd;

    }

    .center-list-group-cell {
        border-width: .5px;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
    }

    .customHeaderLabel {
        text-align: center;
    }
`;

export const HeaderWrapper = styled.div`
    .clcscores-header {
        font-size: 28px;
        font-weight: 500;
        margin-bottom: 20px;
    }
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

export const DetailReportWrapper = styled.div`
    //height: 430px;
    //width: ${p => p.width ? p.width : '100vh'};

    .ag-header {
        background-color: #d9edf7;
        color: black;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-cell::after {
        //border-right: 1px solid #ccc;
        content: " ";
        height: 16px;
        margin-top: 4px;
        position: absolute;
        text-indent: -2000px;
        top: 0;
        right: 0;
    }

    // .ag-body-viewport {
    //     border-left: 1px solid #ccc;
    //     border-bottom: 1px solid #ccc;
    // }

    .ag-floating-top {
        overflow: hidden !important;
    }

    .ag-floating-bottom {
        overflow: hidden !important;
        background-color: #b0e0e6;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-header-group-cell-label {
        justify-content: center;
    }

    .center-list-header {
        background-color: #d9edf7;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: black;
        font-weight: bold;
    }

    .center-list-cell {
        height: 30px;
        border-width: .5px;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
        border-top: .5px solid #ddd;
        border-left: .5px solid #ddd;
        border-right: .5px solid #ddd;
    }

    .center-total-cell {
        height: 30px;
        border-width: .5px;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        // justify-content: center;
        // display: flex;
        border-top: .5px solid #ddd;
        border-left: .5px solid #ddd;
        border-right: .5px solid #ddd;
    }

    .list-header {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-header-right {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-cell-center {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
    }

    .list-cell-right {
        //background-color: #F6CC9F;
        //color: black;
        border-bottom: none;
        text-align: right;
        line-height: 28px;
        border-color: #eee;
    }
    
    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .ag-icon.ag-icon-expanded {
        color: white;
    }

    .ag-icon.ag-icon-contracted {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;